export default [
	// {
	// 	text: '#',
	// 	value: 'id',
	// },
	{
		text: 'folio',
		value: 'purchase_number',
	},
	{
		text: 'tipo',
		value: 'purchase_type',
		align: 'center',
		component: {
			type: 'chip-label',
			props: {
				small: true,
			}
		},
	},
	{
		text: 'rut',
		value: 'rut',
		format: 'rut',
	},
	{
		text: 'proveedor',
		value: 'business_name',
	},
	{
		text: 'vencimiento',
		value: 'date_to_pay',
		format: 'date',
		align: 'right',
	},
	{
		text: 'pagado',
		value: 'total_paid',
		format: 'currency',
		align: 'right',
	},
	{
		text: 'total',
		value: 'total',
		format: 'currency',
		align: 'right',
	},
]